var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, CircularProgress, Link, Stack, Typography } from "@mui/material";
import { GRID_AGGREGATION_ROOT_FOOTER_ROW_ID, GRID_CHECKBOX_SELECTION_FIELD, gridClasses } from "@mui/x-data-grid-premium";
import { productListGet } from "../../modules/stockAdjustment/apiCall";
import { EditableDataGrid } from "../components/editableDataGrid/editableDataGrid";
import { RowModeIds } from "../components/editableDataGrid/editableDataGrid.entity";
import { renderSerialNumberPopup } from "./renderEditPopup";
import { useAppDispatch } from "../../store/hooks";
import { showSurface } from "../../redux/awaitedSurfacesSlice";
import { DemoForm } from "./demoForm";
// const UOMList = ['ml', 'mg', 'tons', 'oz', 'units', 'box', 'bags'].map((it) => ({ label: it, value: it }))
var QtyList = [12, 567, 35, 78, -23];
var checkValidQty = function (qty) {
    var arguments_1 = arguments;
    return __awaiter(this, void 0, void 0, function () {
        var delay;
        return __generator(this, function (_a) {
            delay = arguments_1.length > 1 && arguments_1[1] !== undefined ? arguments_1[1] : 500;
            return [2 /*return*/, new Promise(function (resolve) {
                    setTimeout(function () {
                        resolve(qty >= 0 && qty <= 100);
                    }, delay); // Simulate delay
                })];
        });
    });
};
var renderNameCodeCell = function (_ref) {
    var id = _ref.id, value = _ref.value;
    if (id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID)
        return 'Total';
    if (!(value !== null && value !== void 0 && value.id))
        return null;
    return /*#__PURE__*/ React.createElement(Box, {
        width: "calc(100% - 32px)"
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: "medium",
        textOverflow: "ellipsis",
        overflow: "hidden"
    }, value === null || value === void 0 ? void 0 : value.DisplayName), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        color: "text.tertiary"
    }, "#", (value === null || value === void 0 ? void 0 : value.SkuCode) || (value === null || value === void 0 ? void 0 : value.Code)));
};
export default function DatagridDemo(props) {
    var _a;
    var _this = this;
    var onChange = props.onChange, value = props.value, error = props.error, _b = props.name, name = _b === void 0 ? 'PartDetails' : _b;
    var rows = value[name];
    var pinnedRowsBottom = rows.filter(function (r) { return (r === null || r === void 0 ? void 0 : r.id) === RowModeIds.NewRow; });
    var dispatch = useAppDispatch();
    var columns = [{
            type: 'searchSelect',
            field: 'Part',
            headerName: 'Part name & code',
            editable: true,
            flex: 1,
            minWidth: 250,
            // maxWidth: 300,
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Name; },
            getListData: productListGet,
            apiKey: 'partList',
            placeholder: 'Search Part by name',
            getOptionLabel: function (option) { return option === null || option === void 0 ? void 0 : option.Name; },
            // renderCell: (params) => params.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID ? 'Total' : params.formattedValue, \
            renderCell: renderNameCodeCell,
            valueSetter: function (value, row) {
                return _objectSpread(_objectSpread({}, row), {}, {
                    UOM: value === null || value === void 0 ? void 0 : value.UnitOfMeasurementName,
                    Part: value
                });
            }
        }, {
            type: 'singleSelect',
            field: 'UOM',
            headerName: 'UOM',
            editable: true,
            minWidth: 150,
            renderEditCell: renderSerialNumberPopup,
            flex: 1
        }, {
            type: 'number',
            field: 'Qty',
            headerName: 'Qty',
            editable: true,
            minWidth: 100
        }, {
            type: 'number',
            field: 'Rate',
            headerName: 'Rate (₹)',
            editable: true,
            minWidth: 120
        }, {
            type: 'number',
            field: 'Taxes',
            headerName: 'Taxes (%)',
            editable: true,
            minWidth: 80
        }, {
            type: 'number',
            field: 'Discount',
            headerName: 'Discount',
            editable: true,
            minWidth: 120
        }, {
            type: 'number',
            field: 'Amount',
            headerName: 'Amount (₹)',
            editable: false,
            minWidth: 150,
            valueGetter: function (value, row) { return (row === null || row === void 0 ? void 0 : row.Rate) * (row === null || row === void 0 ? void 0 : row.Qty) * (1 + ((row === null || row === void 0 ? void 0 : row.Taxes) || 0) / 100) - ((row === null || row === void 0 ? void 0 : row.Discount) || 0); }
        }, {
            type: 'date',
            field: 'RequiredFrom',
            headerName: 'Required from',
            editable: true,
            minWidth: 150,
            flex: 1,
            description: 'Date required from'
        }, {
            field: 'Remarks',
            headerName: 'Remarks',
            editable: true,
            flex: 1,
            minWidth: 200,
            maxWidth: 300
        }, {
            type: 'actions',
            field: 'actions',
            headerName: 'Actions',
            minWidth: 100,
            getActions: function (_ref2) {
                var _this = this;
                var id = _ref2.id;
                return id !== GRID_AGGREGATION_ROOT_FOOTER_ROW_ID ? [/*#__PURE__*/ React.createElement(Link, {
                        component: "button",
                        underline: "hover",
                        onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: DemoForm,
                                            containerProps: {
                                                PaperProps: {
                                                    sx: {
                                                        maxWidth: 1200
                                                    }
                                                },
                                                anchor: 'right'
                                            }
                                        }))];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    }, " View ")] : [];
            }
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: rows,
        onChange: onChange,
        dataGridHeader: "Part details",
        isCollapsible: true,
        dataGridProps: {
            checkboxSelection: true,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            disableColumnSorting: true,
            disableColumnFilter: true,
            initialState: {
                pinnedColumns: {
                    left: [GRID_CHECKBOX_SELECTION_FIELD, 'Part'],
                    right: ['Amount', 'actions']
                },
                aggregation: {
                    model: {
                        Amount: 'sum',
                        Discount: 'sum'
                    }
                }
            },
            isCellEditable: function (params) {
                var _params$row;
                return params.field === 'Part' || Boolean((_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.Part);
            },
            getRowHeight: function (params) {
                return params.id === RowModeIds.Aggregation ? 44 : undefined;
            },
            onCellClick: function (_ref3, e, _ref4) {
                var id = _ref3.id, field = _ref3.field, isEditable = _ref3.isEditable, cellMode = _ref3.cellMode;
                var api = _ref4.api;
                if (isEditable && cellMode === 'view') {
                    api === null || api === void 0 || api.startCellEditMode({
                        id: id,
                        field: field
                    });
                }
            },
            getCellClassName: function (params) {
                return params.isEditable ? '' : "".concat(gridClasses.cell, "--disabled");
            },
            sx: (_a = {},
                _a[".".concat(gridClasses["cell--editable"])] = {
                    cursor: 'pointer'
                },
                _a[".".concat(gridClasses.cell, "--disabled")] = {
                    bgcolor: 'secondary.100'
                },
                _a),
            slots: {
                loadIcon: function () { /*#__PURE__*/ return React.createElement(Stack, {
                    alignItems: "center",
                    justifyContent: "center"
                }, /*#__PURE__*/ React.createElement(CircularProgress, {
                    size: 20
                })); }
            }
            // pinnedRows: {
            //     bottom: pinnedRowsBottom
            // }
            // processRowUpdate: async (newRow, oldRow, params) => {
            //     if (!newRow.Part) return { id: params.rowId }
            //     if (newRow?.Part?.id === oldRow?.Part?.id) return newRow;
            //     //apical
            //     const row = {
            //         // ...newRow,
            //         id: newRow.id,
            //         Part: newRow?.Part,
            //         PartId: newRow?.Part?.id,
            //         HSNCode: newRow?.Part?.SkuCode,
            //         Remarks: 'Part Selected'
            //     }
            //     return row
            // },
        },
        validationModel: {
            Taxes: function (value) { return value < 0 ? 'Taxes cannot be less than 0' : ''; },
            UOM: function (value) { return value ? '' : 'This field is required'; },
            Part: function (value) { return value ? '' : 'Please select a part'; },
            Qty: function (value) { return __awaiter(_this, void 0, void 0, function () {
                var isValid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, checkValidQty(value, 300)];
                        case 1:
                            isValid = _a.sent();
                            return [2 /*return*/, isValid ? '' : 'Invalid quantity'];
                    }
                });
            }); }
        },
        cellInfoModel: {
            Part: function (params) {
                var _params$value, _params$value2, _params$value3;
                return params.value ? "Part Name: ".concat((_params$value = params.value) === null || _params$value === void 0 ? void 0 : _params$value.DisplayName, " | Part Code: ").concat((_params$value2 = params.value) === null || _params$value2 === void 0 ? void 0 : _params$value2.SkuCode, " | Part Id: ").concat((_params$value3 = params.value) === null || _params$value3 === void 0 ? void 0 : _params$value3.id) : undefined;
            },
            UOM: function (params) { return params.value ? 'Unit Of Measurement set as default configuration' : ''; }
        },
        error: error === null || error === void 0 ? void 0 : error[name]
    });
}
